import { FC } from 'react';
import { Popover, type PopoverProps } from '@mui/material';

type PopoverWithArrowProps = PopoverProps & {
  xPosition?: number;
};

const PopoverWithArrow: FC<PopoverWithArrowProps> = (popoverProps) => {
  const { xPosition = '50%', slotProps, ...restPopoverProps } = popoverProps;
  const { paper, ...slotWithoutPaper } = slotProps ?? {};
  const { sx: paperSx, ...paperWithoutSx } = (paper ?? {}) as any;

  return (
    <Popover
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'right', vertical: -5 }}
      slotProps={{
        paper: {
          sx: {
            overflow: 'visible',
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: xPosition,
              width: 10,
              height: 10,
              backgroundColor: 'inherit',
              transform: 'translateY(-50%) rotate(45deg)',
              boxShadow: '-3px -3px 5px -2px rgba(0,0,0,0.1)',
            },
            ...paperSx,
          },
          ...paperWithoutSx,
        },
        ...slotWithoutPaper,
      }}
      {...restPopoverProps}
    />
  );
};

export default PopoverWithArrow;
